import { Injectable } from "@angular/core";

@Injectable()
export class AccountPass {
  public id: string;
  public passType: string;
  public name: string;
  public passNumber: string;
  public paymentPending: boolean;
  public tempTag: string;
  public tempTagId: number;
  public usage: number;
  public closedDt: string;
  public description: string;
  public evExpiryDt: string;

  constructor() {}
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/shared/models/account-pass.ts